'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { PhnxAvatar } from '../../01-atoms/Avatar/Avatar'
import { PhnxIndustry } from './Industry'

interface IndustryBlokProps {
  blok: { author: any; content: any; relatedServices: any } & SbBlokData
  rels?: any
  name: string
}

const Industry: FC<IndustryBlokProps> = ({ blok, rels, name }) => {
  const [authorRel, setAuthorRel] = useState<any>(rels)
  const [callbackLink, setCallbackLink] = useState<string>('/contact-us/general')

  useEffect(() => {
    const author = rels?.find((rel: any) => rel.uuid === blok.author)

    if (author) {
      setAuthorRel(author)
      setCallbackLink(`/${author.full_slug}?requestCallback=true`)
    }
  }, [blok.author, rels])

  const [relatedServices, setRelatedServices] = useState<any[]>([])
  useEffect(() => {
    if (blok.relatedServices && blok.relatedServices.length > 0) {
      const relatedServicesFind = blok.relatedServices.map((uuid: any) => {
        return rels?.find((rel: any) => rel.uuid === uuid) as any
      })

      const relatedServicesArray = relatedServicesFind.map((article: any) => {
        return {
          title: article?.name,
          href: `/${article?.full_slug}`,
        }
      })
      setRelatedServices(relatedServicesArray)
    }
  }, [blok.relatedServices])
  return (
    <div {...storyblokEditable(blok)}>
      <h1 className={'sr-only'}>{name}</h1>
      <PhnxIndustry
        advisor={authorRel && authorRel.content && authorRel.name}
        avatar={
          authorRel &&
          authorRel.content && (
            <PhnxAvatar
              asset={{ src: authorRel.content.image.filename, alt: authorRel.content.image.alt }}
              size="extralarge"
              style="square"
            />
          )
        }
        callback={callbackLink}
        content={
          blok.content &&
          blok.content.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        relatedServices={relatedServices}
      />
    </div>
  )
}

export default Industry
